.order-docs-button{background-color:transparent;border-style:solid;border-color:#d3d3d3;border-radius:.5rem}
/*# sourceMappingURL=upload-document.component-3CRAAEXH.css.map */
